// src/components/layout/MenuItem.tsx
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as S from './Sidebar.styles';
import { MenuItemType } from './sidebar.data';
import { FiChevronRight } from 'react-icons/fi';

interface Props {
  item: MenuItemType;
  isSidebarOpen: boolean;
}

const MenuItem: React.FC<Props> = ({ item, isSidebarOpen }) => {
  const { pathname } = useLocation();
  const hasChildren = !!item.children?.length;
  const isActive = pathname === item.path || pathname.startsWith(`${item.path}/`);
  const [subOpen, setSubOpen] = useState(isActive);

  const toggle = () => { if (isSidebarOpen) setSubOpen(!subOpen); };

  if (hasChildren) {
    return (
      <S.NavItemContainer className="has-children">
        <S.MenuItemButton onClick={toggle} isActive={isActive && isSidebarOpen}>
          <item.icon className="icon" />
          {isSidebarOpen && <span className="item-text">{item.name}</span>}
          <FiChevronRight className="arrow-icon" style={{
            transform: subOpen && isSidebarOpen ? 'rotate(90deg)' : 'rotate(0deg)'
          }} />
        </S.MenuItemButton>

        {isSidebarOpen ? (
          <S.SubMenu isOpen={subOpen}>
            {item.children?.map(c => (
              <S.SubMenuItem
                key={c.path}
                to={c.path}
                className={pathname === c.path ? 'active' : ''}
              >
                <c.icon className="icon" />
                <span className="item-text">{c.name}</span>
              </S.SubMenuItem>
            ))}
          </S.SubMenu>
        ) : subOpen ? (
          <S.FlyoutSubMenu className="visible">
            {item.children?.map(c => (
              <S.FlyoutSubMenuItem key={c.path} to={c.path}>
                <c.icon className="icon" />
                <span className="item-text">{c.name}</span>
              </S.FlyoutSubMenuItem>
            ))}
          </S.FlyoutSubMenu>
        ) : null}
      </S.NavItemContainer>
    );
  }

  return (
    <S.NavItemContainer>
      <S.NavItemLink
        to={item.path}
        end
        title={isSidebarOpen ? undefined : item.name}
      >
        <item.icon className="icon" />
        {isSidebarOpen && <span className="item-text">{item.name}</span>}
      </S.NavItemLink>
    </S.NavItemContainer>
  );
};

export default MenuItem;
